module.exports = __webpack_public_path__ + "img/nav_active_bg_.866b83e9.png";